/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Select } from 'sarsaparilla';
import RenderIf from '../../utils/JSXUtils';

export default class SelectInput extends PureComponent {
    static propTypes = {
        id: PropTypes.string.isRequired,
        label: PropTypes.string,
        value: PropTypes.string.isRequired,
        options: PropTypes.arrayOf(
            PropTypes.shape({
                label: PropTypes.string.isRequired,
                value: PropTypes.string.isRequired,
            })
        ).isRequired,
        className: PropTypes.string,
        disabled: PropTypes.bool,
        required: PropTypes.bool,
        validator: PropTypes.func,
        isValid: PropTypes.bool,
        error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
        showError: PropTypes.bool,
        onChange: PropTypes.func.isRequired,
    };

    static defaultProps = {
        disabled: false,
        validator: () => false,
        isValid: true,
        error: false,
        showError: true,
        required: false,
        label: 'Select an option',
    };

    constructor(props) {
        super(props);

        this.state = {
            isValid: this.props.isValid,
            error: this.props.error,
        };

        this.onChange = this.onChange.bind(this);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.isValid !== this.props.isValid) {
            this.setState((prevState) => ({
                ...prevState,
                isValid: nextProps.isValid,
                error: nextProps.error,
            }));
        }
    }

    onChange(evt) {
        const value = evt.target.value;
        const error = this.props.validator(value);
        const isValid = !error;

        this.setState(
            (prevState) => ({ ...prevState, isValid, error }),
            () => {
                if (this.props.onChange) {
                    this.props.onChange(value, isValid, error);
                }
            }
        );
    }

    render() {
        const { id, label, value, options, className, disabled, required, showError } =
            this.props;
        const { isValid, error } = this.state;
        const classes = `rec-form-item-wrap ${className}`;

        return (
            <div className={classes}>
                <Select
                    label={label}
                    isRequired={required}
                    id={id}
                    options={options}
                    onChange={this.onChange}
                    value={value}
                    isInvalid={!isValid}
                    isDisabled={disabled}
                />
                {RenderIf(showError && !isValid)(<div>{error}</div>)}
            </div>
        );
    }
}
